/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `youtube` - YouTube
 * `manual` - 수동 입력
 */
export type TrendAnalysisResultSourceEnum =
  (typeof TrendAnalysisResultSourceEnum)[keyof typeof TrendAnalysisResultSourceEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrendAnalysisResultSourceEnum = {
  youtube: "youtube",
  manual: "manual",
} as const;
